import { render } from "./unlink.html?vue&type=template&id=7b017624&scoped=true&ts=true"
import script from "./unlink.vue?vue&type=script&lang=ts"
export * from "./unlink.vue?vue&type=script&lang=ts"

import "./unlink.scss?vue&type=style&index=0&id=7b017624&scoped=true&lang=scss"

import exportComponent from "/builds/customer/line/line-web-loyalty/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b017624"]])

export default __exports__